import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthComponent} from './auth.component';
import {RouterModule} from '@angular/router';
import {LoadingPageModule} from '@dcp/configurator';
import {LogoutGuard} from '@spartacus/storefront';
import {
  ContentLoadingIndicatorModule
} from '../shared/content-loading-indicator/content-loading-indicator.module';
import {LoginModule} from './login/login.module';
import {DcpLogoutGuard} from './logout/dcp-logout.guard';
import {BaselineComponent} from './baseline/baseline.component';

@NgModule({
  declarations: [AuthComponent, BaselineComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([{
      path: 'auth',
      component: AuthComponent
    },
      {
        path: 'baseline/:action',
        component: BaselineComponent,
      }]),
    ContentLoadingIndicatorModule,
    LoginModule,
    LoadingPageModule,
  ],
  exports: [RouterModule],
  providers: [
    {provide: LogoutGuard, useExisting: DcpLogoutGuard},
  ]
})
export class AuthModule {
}
